var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "shoppable-instagram-container" }, [
    _vm.heroSchema.title
      ? _c("h2", [_vm._v(_vm._s(_vm.heroSchema.title))])
      : _vm._e(),
    _c("div", {
      staticClass: "yotpo yotpo-pictures-widget",
      attrs: { "data-gallery-id": "5f848f8a19d86f4270716140" }
    })
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }